// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Aside{z-index:4;width:0;top:0;left:auto;right:0;transition:.8s !important}.Aside .components{display:none}.Aside .components.active{display:block}@media screen and (max-width: 992px){.Aside{position:absolute !important;z-index:6}}", ""]);
// Exports
module.exports = exports;
